module.exports = __webpack_public_path__ + "img/about-ch4-sectors-urban-mobility.cf9595d9.png";